import React from 'react';
import { Switch as MaterialSwitch, SwitchProps as MaterialSwitchProps } from '@mui/material';

export interface CheckboxProps extends Omit<MaterialSwitchProps, 'value' | 'checked' | 'onBlur'> {
  value?: boolean;
  onBlur?: () => void;
}

export const Switch: React.FC<CheckboxProps> = ({ value, onChange, onBlur, ...rest }) => {
  return <MaterialSwitch checked={value} onChange={onChange} onBlur={onBlur} {...rest} />;
};
